import VuexPersist from 'vuex-persist'

import actions from '@/store/actions';
import getters from '@/store/getters';
import mutations from "@/store/mutations";

import {createStore} from "vuex";


const vuexPersist = new VuexPersist({
    key: 'makemymosaic-preview',
    storage: window.localStorage
})

export default createStore({
    plugins: [vuexPersist.plugin],
    state: {
        step: 1,
        preview: null,
        finished_previews: [],
        header_count: 0,
        tile_count: 0,
        header_url: '',
        header_file: null,
        tile_images: [],
        email: null,
        preview_date: Date.now()
    },
    mutations,
    actions,
    getters
})
